export default data => {
  const { src, type = 'image' } = data;

  switch (type) {
    case 'svg': {
      return new Promise(async (resolve, reject) => {
        try {
          const margin = 0.95;
          const response = await fetch(src);

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG: ${response.status}`);
          }

          const svgString = await response.text();
          // Create a temporary DOM element to parse the SVG
          const parser = new DOMParser();
          const doc = parser.parseFromString(svgString, 'image/svg+xml');
          const svg = doc.documentElement;

          // Get current viewBox
          const viewBox = svg
            .getAttribute('viewBox')
            .split(' ')
            .map(Number);
          const [x, y, width, height] = viewBox;

          // Calculate new viewBox
          const newX = x - margin;
          const newY = y - margin;
          const newWidth = width + 2 * margin;
          const newHeight = height + 2 * margin;

          // Update viewBox
          svg.setAttribute(
            'viewBox',
            `${newX} ${newY} ${newWidth} ${newHeight}`
          );

          // Return as string
          const newSvgString = new XMLSerializer().serializeToString(svg);

          resolve(newSvgString);
        } catch (error) {
          console.error('Error loading SVG:', error);
          reject(error);
        }
      });
    }
    default: {
      return new Promise((resolve, reject) => {
        const quietZoneFraction = 0.05;
        const img = new Image();

        img.crossOrigin = 'anonymous';
        img.src = src;

        img.onload = () => {
          const originalWidth = img.width;
          const originalHeight = img.height;

          // Calculate quiet zone margins
          const marginX = originalWidth * quietZoneFraction;
          const marginY = originalHeight * quietZoneFraction;

          // Create an in-memory canvas
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = originalWidth + 2 * marginX;
          canvas.height = originalHeight + 2 * marginY;

          // Fill background (quiet zone) with white
          ctx.fillStyle = 'transparent';
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          // Disable smoothing for sharp images
          ctx.imageSmoothingEnabled = false;
          ctx.msImageSmoothingEnabled = false;

          // Draw the original image centered in the quiet zone
          ctx.drawImage(img, marginX, marginY, originalWidth, originalHeight);

          // Convert back to Base64 (PNG format)
          const newBase64 = canvas.toDataURL();

          resolve(newBase64);
        };

        img.onerror = err => reject(err);
      });
    }
  }
};
